/**
 * „Nachzuerfassen“ (ADR 0026): unbekannte Codes, die ohne Netz gescannt
 * wurden.
 *
 * Gemerkt wird ohne einen Tipp -- unter Zeitdruck tippt niemand, und dann ist
 * der Code weg. Die Liste liegt nur auf diesem Gerät. Mit Netz legt man die
 * Einträge von der Seite „Scannen“ aus an.
 */

import { aufloesenIn } from "../scan/aufloesen.js";
import type { Bestand } from "./bestand.js";
import { db, type NachzuerfassenderCode } from "./datenbank.js";

export type { NachzuerfassenderCode } from "./datenbank.js";

/** Merkt einen Code. Steht er schon da, bleibt der erste Eintrag. */
export async function merken(
  code: string,
  vorschlag: string | null,
  ort_id: string | null,
): Promise<void> {
  const schluessel = code.trim();
  if (schluessel === "") return;
  await db.transaction("rw", db.nachzuerfassen, async () => {
    if ((await db.nachzuerfassen.get(schluessel)) !== undefined) return;
    await db.nachzuerfassen.put({
      code: schluessel,
      vorschlag,
      erfasst_am: new Date().toISOString(),
      ort_id,
    });
  });
}

export async function entfernen(code: string): Promise<void> {
  await db.nachzuerfassen.delete(code.trim());
}

/** Die Einträge, der älteste zuerst. */
export function alle(): Promise<NachzuerfassenderCode[]> {
  return db.nachzuerfassen.orderBy("erfasst_am").toArray();
}

/**
 * Was die lokale Kopie inzwischen kennt, weil jemand anders das Gerät
 * angelegt hat. Diese Einträge fallen heraus.
 */
export function erledigte(
  bestand: Bestand,
  eintraege: readonly NachzuerfassenderCode[],
): NachzuerfassenderCode[] {
  return eintraege.filter((e) => aufloesenIn(bestand, e.code).art !== "unbekannt");
}
